import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const Minus = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12.6875C4 12.1352 4.44772 11.6875 5 11.6875H19C19.5523 11.6875 20 12.1352 20 12.6875C20 13.2398 19.5523 13.6875 19 13.6875H5C4.44772 13.6875 4 13.2398 4 12.6875Z"
      fill="currentColor"
    />
  </svg>
));

export default Minus;
